/**
 * Opens a URL in a new tab/window
 * @param url - The URL to open
 */
export const openLink = (url: string): void => {
  if (typeof window !== 'undefined') {
    window.open(url, '_blank', 'noopener,noreferrer')
  }
}
